import WebsiteBehaviors from "../website-behaviors/index.js";

class EbscoPdf extends WebsiteBehaviors {
	identifier() {
		return "EbscoPdf";
	}

	static isPDF() {
		return true;
	}

	// @ts-expect-error TS(7006) FIXME: Parameter 'location' implicitly has an 'any' type.
	static test(location) {
		return location.pathname.match(/\/ContentServer\.asp/);
	}

	shouldFrameTakeControl() {
		return true;
	}
}

export default EbscoPdf;
